import { render, staticRenderFns } from "./notificationItem.vue?vue&type=template&id=71801aa2&scoped=true&"
import script from "./notificationItem.vue?vue&type=script&lang=js&"
export * from "./notificationItem.vue?vue&type=script&lang=js&"
import style0 from "./notificationItem.vue?vue&type=style&index=0&id=71801aa2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71801aa2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
